<prism-ui-page-header is-portal-header=false key-id="story-1" hide-mobile-nav="true">
  <div slot="logo">
    @if (isStandardTheme) {
      <prism-ui-logo-link
        class="standard-logo"
        key-id="standard-logo"
        alt="standard-link"
        link-id="standard-link"
        img src="assets/logo/sfg-logo.svg"
        (click)="iconClick()"
        url="https://www.standard.com">
      </prism-ui-logo-link>
    }
    @if (!isStandardTheme) {
      <prism-ui-logo-link
        class="nwm-logo"
        key-id="Northwestern-logo"
        alt="nwm-link"
        link-id="nwm-link"
        (click)="iconClick()"
        src-mobile="assets/logo/nwm-brandmark-mobile.svg"
        src-desktop="assets/logo/nwm-brandmark-desktop.svg"
        url="https://www.northwesternmutual.com">
      </prism-ui-logo-link>
    }
  </div>
  <div slot="navigation">
    <prism-ui-header-navigation key-id="header-navigation" navigation-items-count="1">
      <prism-ui-icon
        slot="1"
        icon-name="circle-question"
        key-id="help-circle"
        size="lg"
        spin="false"
        class="info"
        (click)="openContactUsModal()"
        variant="inherit">
      </prism-ui-icon>
    </prism-ui-header-navigation>
  </div>
</prism-ui-page-header>
<prism-ui-modal key-id="contact-us-modal" has-dark-overlay="true">
  <prism-ui-heading
    slot="modal-header"
    key-id="contact-us-modal"
    font-size="sm"
    font-weight="strong"
    >{{contactUsContentHeading}}</prism-ui-heading
    >
    <prism-ui-copy
      slot="modal-body"
      key-id="contact-us-modal"
      [innerHTML]="contactUsContentBody"
      >
    </prism-ui-copy>
    <div slot="modal-footer" >
      <div class="modalButtonStyling">
        <prism-ui-button class="center"
          button-width="content"
          key-id="continue-button"
          size="md"
          variant="primary"
          type="button"
          is-icon-right-aligned="false"
          (click)="onCancelModal()"
        >Close</prism-ui-button>
      </div>
    </div>
  </prism-ui-modal>
